import React, { FunctionComponent, useState, useEffect, useRef } from 'react';
import { RecordingModel } from 'features/recordings/RecordingModel';
import { Card } from 'components/Card';
import { useSelector } from 'react-redux';
import { RootState } from 'rootReducer';
import { Loader } from 'components/Loader';
import { useSubdomain } from 'hooks/useSubdomain';
import { fetchRecordings } from 'features/recordings/recordingsSlice';
import { useDispatch } from 'react-redux';
import { useInView } from 'react-intersection-observer';

export interface InfiniteScrollRecordingsProps {
  recordings: RecordingModel[];
  itemsPerPage: number;
}

export const InfiniteScrollRecordings: FunctionComponent<
  InfiniteScrollRecordingsProps
> = ({ recordings, itemsPerPage }) => {
  const [currentItems, setCurrentItems] = useState<RecordingModel[]>([]);
  const [itemOffset, setItemOffset] = useState(0);
  const currentPageRef = useRef(1);
  const loading = useSelector((state: RootState) => state.recordings.isLoading);
  const pageCount = useSelector(
    (state: RootState) => state.recordings.pageCount
  );
  const subdomain = useSubdomain();
  const dispatch = useDispatch();
  const { ref, inView } = useInView({
    threshold: 0
  });

  useEffect(
    function setCurrentRecordings() {
      const endOffset = itemOffset + itemsPerPage;
      console.log(`Loading recordings from ${itemOffset} to ${endOffset}`);
      setCurrentItems(recordings);
    },
    [itemOffset, itemsPerPage, recordings]
  );

  useEffect(
    function fetchRecordingsOnScroll() {
      if (inView && currentPageRef.current <= pageCount) {
        dispatch(fetchRecordings(subdomain, currentPageRef.current + 1));
        const newOffset = currentPageRef.current * itemsPerPage;
        setItemOffset(newOffset);
        currentPageRef.current += 1;
      }
    },
    [inView, dispatch, itemsPerPage, pageCount, subdomain]
  );

  return (
    <div className="container--wide">
      <h1>Recordings</h1>
      <ul className="list--reset grid">
        {currentItems.map((recording, index) => {
          const lastElement = index === currentItems.length - 1;
          return (
            <li
              className="col-xss-12 col-xs-6"
              key={recording.id}
              ref={lastElement ? ref : null}
            >
              <Card
                id={recording.id}
                url={`/recordings/${recording.id}`}
                title={`${recording.title}`}
                artworkKey={recording.artworkKey}
                artworkMode={'recording'}
                type={'recording'}
              />
            </li>
          );
        })}
      </ul>
      {loading && (
        <div className="text--center mar-t mar-b">
          <Loader />
        </div>
      )}
    </div>
  );
};
